module.exports = __webpack_public_path__ + "files/SPIADI2026 - Fiche données d'activité - dénominateurs.f1263bee94ccfc9f3c11955ad2e7ed84.pdf";